module.exports = __webpack_public_path__ + "img/list45.76b72ada.jpeg";